export default __webpack_public_path__ + "static/media/general.7b10bb2a.svg";